import React, { useState } from "react";
import { useParams } from "react-router-dom";
import FileUpload, {
	FileUploadState,
} from "../dashboard/VCApplication/FileUpload";
import { Button, Modal, Spin } from "antd";
import { toast } from "react-toastify";

import { useUserContext } from "../../Contexts/UserContext";

// interface UploadEvidenceProps {
//     caseId: string | undefined; // Add caseId to the component's props
// }

type EvidenceData = {
	caseId: string;
	name: string;
	description: string;
	createdById: string;
	url: string;
};

const UploadEvidence: React.FC = () => {
	const [fileUploads, setFileUploads] = useState<FileUploadState[]>([
		{ file: null, name: "", description: "", ext: "" },
	]);
	const params = useParams<{ id: string }>();
	const { id: caseId } = params;
	const [isLoading, setIsLoading] = useState(false);
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	const authToken = sessionStorage.getItem("token");

	const { userData } = useUserContext();

	const showUploadModal = () => {
		setIsUploadModalOpen(true);
	};

	const closeUploadModal = () => {
		setIsUploadModalOpen(false);
	};

	const getUploadURL = async (contentType: string) => {
		console.log(caseId)
		const response = await fetch(
			"https://backend-kyw8.onrender.com/cases/evidence/upload-url",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${authToken}`,
				},
				body: JSON.stringify({ caseId, contentType }),
			}
		);

		const data = await response.json();

		if (!response.ok) {
			console.log('error occured while getting url')
			throw new Error(data.error ?? "An error occured ");
		}

		return data;
	};

	const uploadToS3 = async (URL: string, file: Blob, contentType: string) => {
		const response = await fetch(URL, {
			method: "PUT",
			headers: {
				"Content-Type": contentType,
			},
			body: file,
		});

		if (!response.ok) {
			console.log('error occured while uploading files')
			throw new Error("An error occured while uploading the file(s)");
		}
	};

	const createEvidence = async (evidenceData: EvidenceData) => {
		const response = await fetch(
			"https://backend-kyw8.onrender.com/cases/evidence",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${authToken}`,
				},
				body: JSON.stringify(evidenceData),
			}
		);

		if (!response.ok) {
			console.log('error occured while saving')
			throw new Error("An error occured while uploading the file(s)");
		}
	};

	const handleSubmit = async () => {
		setIsLoading(true);

		try {
			await Promise.all(
				fileUploads.map(async (file) => {
					if (file.file) {
						const data = await getUploadURL(file.ext);
						const { uploadURL, fileURL } = data;

						const blob = new Blob([file.file], { type: file.ext });

						await uploadToS3(uploadURL, blob, file.ext);

						await createEvidence({
							name: file.name,
							description: file.description,
							url: fileURL,
							caseId: caseId!,
							createdById: userData.id,
						});
					}
				})
			);
			setIsLoading(false);

			toast.success("Evidence was successfully uploaded", {
				position: "top-center",
			});
		} catch (error) {
			console.error("Error submitting form:", error);
			toast.error("An unexpected error occurred. Please try again later.", {
				position: "bottom-right",
			});
			setIsLoading(false);
		}
	};

	return (
		<div>
			<button className="flex justify-left font-bold" onClick={showUploadModal}>
				Tender Evidence
			</button>
			<Modal
				title=""
				className="w-fit "
				open={isUploadModalOpen}
				onCancel={closeUploadModal}
				footer={[
					<Button key="close" onClick={closeUploadModal}>
						Close
					</Button>,
				]}
				style={{ maxHeight: "400px", overflowY: "auto" }}>
				<FileUpload fileUploads={fileUploads} setFileUploads={setFileUploads} />
				<Button disabled={isLoading} onClick={handleSubmit}>
					{isLoading? <Spin size="small" /> : 'Upload' }
				</Button>
			</Modal>
		</div>
	);
};
export default UploadEvidence;
